'use strict';
define([
    '../../utils/CommonUtil',
    '../../g2'
    ],
    function (
        CommonUtil,g2
    ) {
        var COMMANDNAMES={
            'NoopTool':'NoopTool',
            'PlotEdit':'PlotEdit'
        };
        // 借助平台帮助方法，实现一个继承自 g2.cmds.Tool 的 freedrawtoolline
        var freedrawtoolpolygon = function (opts) {
            var optss = opts || {};
            optss.cursor = optss.cursor || 'crosshair'; // 设置鼠标样式为十字丝
            g2.interact.Tool.call(this, optss);
            this.drawElement = null; // 定义当前绘制的Element
            this.geoBuilder = new g2.draw.GeometryBuilder(); // 创建几何图形构造器工具实例
            this.isEndDraw = true; // 标示是否在绘制中
            this.geoLinePolygon = null;
        }
        g2.core.ClassUtil.extend2(freedrawtoolpolygon, g2.interact.Tool);
        // 在Tool被激活时触发，继承自 g2.cmd.ToolBase
        freedrawtoolpolygon.prototype.onClick = function (param) {
            // 复用基类的 onClick 实现
            freedrawtoolpolygon.prototype.uber.onClick.call(this, param);
            this.pushNum = 0;
        }
        // Tool初始化时触发，继承自 g2.cmds.Tool
        freedrawtoolpolygon.prototype.onCreate = function (hook) {
            // 复用基类的 onCreate 实现
            freedrawtoolpolygon.prototype.uber.onCreate(hook);
            this.map = hook['map']; // 设置当前map
            this.srid = hook['spatialRef']; // 设置当前空间参考
            this.callBack = hook['callBack'];
            this.templateElement = hook['templateElement'];
            this.drawLayer = hook['drawLayer'];
            this.fillSymbol  =  hook['fillSymbol'];
            this.pattern  =  hook['pattern'];
            this.type  =  hook['type'];
            this.appevent = hook['appevent'];
            this.context = hook['context'];
            this.contextx = hook['contextx'];
        }
        /***
         * 鼠标单击事件处理方法
         * @param Number button 按下的鼠标按键
         * @param Number shift 是否同时按下的键盘上的shift键
         * @param Number screenx 事件发生时鼠标在屏幕上的X坐标
         * @param Number screeny 事件发生时鼠标在屏幕上的Y坐标
         * @param Number mapx 鼠标在地图上的X坐标
         * @param Number mapy 鼠标在地图上的Y坐标
         * @param Number handled 该事件是否已经不需要再处理
         */
        freedrawtoolpolygon.prototype.onMouseClick = function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (!this.templateElement) return;
            if (!this.isEndDraw) return;
            this.map.stopDbClick(); // 停止地图双击放大功能
            this.isEndDraw = false;
            // 向当前标绘的Element中加第一个点
            var point = new g2.sfs.Point({x: mapx, y: mapy, spatialReference: this.srid});
            this.drawElement = this.templateElement.copy(); // 由模板Element创建当前标绘的Element
            var geo = this.drawElement.geometry;
            var geo = this.drawElement.geometry;
            if (geo.paths[0].points[1].x == 0 && geo.paths[0].points[1].y == 0) {
                geo.removePoint(geo.paths[0].points[1]);
            }
            if (geo.paths[0].points[0].x == 0 && geo.paths[0].points[0].y == 0) {
                geo.removePoint(geo.paths[0].points[0]);
            }
            this.geoBuilder.build(geo, point, 1, this.pushNum); // 注意参数1是构建开始
            this.drawLayer.add(this.drawElement);
        }
        /***
         * 鼠标位置发生改变时的处理方法
         * @param Number button 鼠标移动时按下的鼠标按键
         * @param Number shift 是否同时按下的键盘上的shift键
         * @param Number screenx 事件发生时鼠标在屏幕上的X坐标
         * @param Number screeny 事件发生时鼠标在屏幕上的Y坐标
         * @param Number mapx 鼠标在地图上的X坐标
         * @param Number mapy 鼠标在地图上的Y坐标
         * @param Number handled 该事件是否已经不需要再处理
         */
        freedrawtoolpolygon.prototype.onMouseMove = function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (!this.isEndDraw) {
                // 向当前绘制的Element中持续加点
                var point = new g2.sfs.Point({x: mapx, y: mapy});
                this.context._lastControlPoint=point;
                var geo = this.drawElement.geometry;
                if (geo.paths[0].points[1].x == 0 && geo.paths[0].points[1].y == 0) {
                    geo.removePoint(geo.paths[0].points[1]);
                }
                if (geo.paths[0].points[0].x == 0 && geo.paths[0].points[0].y == 0) {
                    geo.removePoint(geo.paths[0].points[0]);
                }
                this.geoBuilder.build(geo, point, 2, this.pushNum); // 参数2是构建过程中加点
                this.drawLayer.update(this.drawElement);
            }
        }
        /***
         * 鼠标双击事件处理方法
         * @param Number handled 该事件是否已经不需要再处理
         */
        freedrawtoolpolygon.prototype.onDblclick = function (handled) {
            var self = this;
            if(self.isEndDraw){
                return;
            }
            self.isEndDraw = true;
            var geo = self.drawElement.geometry;
            geo.removePoint(geo.paths[0].points[1]);
            geo.removePoint(geo.paths[0].points[0]);
            geo.paths[0].spatialReference = this.srid;
            self.geoBuilder.build(geo, null, 4, self.pushNum); // 参数4是结束构建
            //清空之前的面
            self.geoLinePolygon = null;
            // 抽稀，并进行线转面
            self.lintToPolygon(self,geo);
            var opts={};
            opts.geometry=self.geoLinePolygon;
            opts.symbol=self.fillSymbol;
            opts.name='freePlot';
            var plotElement = self.context._constructPlotElement(self.pattern,opts);
            self.drawLayer.remove(self.drawElement);
            self.drawLayer.add(plotElement);
            self.pushNum = 0;
            self.map.resumeDbClick(); // 恢复地图双击放大功能
            self.drawElement = null; // 释放资源

            var commandManager = new g2.gdm.CommandManager();
            //创建命令通知实例，用来命令之间的相互通知，传入命令管理对象
            var commandNotify = new g2.gdm.CommandNotify({
                manager: commandManager
            });
            var nooptool = new g2.interact.NoopTool({
                id: COMMANDNAMES.NoopTool,
                cursor: 'pointer'
            });
            commandManager.add(nooptool);
            var graphicSet = new g2.carto.GraphicSelectionSet();
            commandManager.onCreate({
                map: self.map,
                commandNotify: commandNotify,
                graphicSelectionSet: graphicSet,
                spatialRef: {
                    srid: self.srid
                }
            });
            var reader = new jsts.io.GeoJSONReader();
            var input = reader.read(self.geoLinePolygon.asGeoJson());
            if(CommonUtil.isFunction(self.callBack)){
                if(input.isValid()){
                    self.callBack.call(self.contextx,self.geoLinePolygon.asGeoJson());
                }else{
                    self.callBack.call(self.contextx,null);
                }
            }
            // 从FreeDrawTool切换回地图默认的“无操作”模式
            commandNotify.activeCommand(COMMANDNAMES.NoopTool);
            //事件通知
            this.context._fireEvent(this.appevent,{
                type:this.type,//标绘类型
                element:plotElement//标绘元素
            });
            this.context._cancelPlot();
            //
            this.context._resetToolState();
        }
        //调用方法主动结束
        freedrawtoolpolygon.prototype.endDraw=function(){
            this.onDblclick();
        }
        /***
         * 线转面并进行抽稀
         */
        freedrawtoolpolygon.prototype.lintToPolygon = function(self,geo){
            var WKTPolygon = "POLYGON((";
            if(geo.paths.length == 1) {
                //判断是不是大于200个点，是的话进行抽稀
                var polygonPoints = geo.paths[0].points;
                polygonPoints.push(polygonPoints[0]);
                var polygonPointsLength = polygonPoints.length;
                var arrNew = [];
                if(polygonPointsLength > 200) {
                    var numExceed = polygonPointsLength - 200;
                    if(polygonPointsLength <= 400) {
                        var numInterval = Math.floor(polygonPointsLength / numExceed);
                        var abc = 1;
                        for(var f = 0; f < polygonPointsLength; f++) {
                            if(f == (abc * numInterval)) {
                                abc++;
                                if(f == 0 || f == 1 || f == (polygonPointsLength - 1) || f == (polygonPointsLength - 2)) {
                                    arrNew.push(polygonPoints[f]);
                                }
                            } else {
                                arrNew.push(polygonPoints[f]);
                            }
                        }
                    } else {
                        var numInterval = Math.ceil(polygonPointsLength / 200);
                        var abc = 1;
                        for(var f = 0; f < polygonPointsLength; f++) {
                            if(f == (abc * numInterval)) {
                                abc++;
                                arrNew.push(polygonPoints[f]);
                            } else {
                                if(f == 0 || f == 1 || f == (polygonPointsLength - 1) || f == (polygonPointsLength - 2)) {
                                    arrNew.push(polygonPoints[f]);
                                }
                            }
                        }
                    }
                    polygonPoints = arrNew;
                    polygonPointsLength = polygonPoints.length;
                }
                for(var i = 0; i < polygonPoints.length - 1; i++) {
                    WKTPolygon = WKTPolygon + polygonPoints[i].x.toFixed(5) + ' ' + polygonPoints[i].y.toFixed(5) + ",";
                }
                WKTPolygon = WKTPolygon + polygonPoints[polygonPointsLength - 1].x.toFixed(5) + ' ' + polygonPoints[polygonPointsLength - 1].y.toFixed(5);
            }
            WKTPolygon = WKTPolygon + "))";
            //创建面
            self.geoLinePolygon = new g2.sfs.GeometryFormatter.fromWKT(WKTPolygon , self.srid);
            self.geoLinePolygon.shell.spatialReference = self.srid;
            let points = self.geoLinePolygon.shell.points;
            for (let d=0;d<points.length;d++){
                points[d].spatialReference = self.srid;
            }
        }

        return freedrawtoolpolygon;
    }
)
